import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import '@aws-amplify/ui-react/styles.css';

ReactDOM.render(<App />, document.getElementById('root'));
